import { memo, useState } from 'react'
import { Checkbox, Flex, Popover } from 'antd'
import { CloseOutlined, FilterOutlined } from '@ant-design/icons'
import { useIntl } from 'react-intl'
import Button from '../../../../common/Button'
import NoRecordsFound from '../../../../common/NoRecordsFound'
import {
  useCandidateContext,
  SELECT_DESELECT_CONNECTOR_CATEGORIS,
} from '../context/context'

const CategoryFilterPopover = () => {
  const intl = useIntl()
  const [state, dispatch] = useCandidateContext()
  const [open, setOpen] = useState(false)

  return (
    <Popover
      open={open}
      onOpenChange={setOpen}
      trigger="click"
      placement="bottomRight"
      classNames={{ body: 'category-filter-popover' }}
      title={
        <Flex justify="space-between" align="center">
          {intl.formatMessage({ id: 'functionalDiagram.selectCategory' })}
          <Button
            type="text"
            icon={<CloseOutlined />}
            className="ant-popover-close"
            onClick={() => setOpen(false)}
            aria-label="Close"
            testId="fd-category-close"
          />
        </Flex>
      }
      content={
        <Flex vertical gap={8} style={{ width: 280 }}>
          {state.connectorCategories?.map((category) => (
            <Checkbox
              key={category.value}
              data-testid="fd-category-option"
              checked={state.selectedConnectorCategories.includes(
                category.value
              )}
              onChange={() =>
                dispatch({
                  type: SELECT_DESELECT_CONNECTOR_CATEGORIS,
                  data: category.value,
                })
              }
            >
              {category.name}
            </Checkbox>
          ))}
          {(!state.connectorCategories || state.connectorCategories.length === 0) && (
            <NoRecordsFound />
          )}
        </Flex>
      }
    >
      <Button
        icon={<FilterOutlined />}
        testId="fd-category-filter"
        className={
          state.selectedConnectorCategories?.length > 0 ? 'filter-active' : ''
        }
      />
    </Popover>
  )
}

export default memo(CategoryFilterPopover)
